"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeClasses = void 0;
/**
 * A function that creates theme classes from a valid theme key. Useful for adding necessary theme classes to any element, namely the inner theme provider div.
 * @param themeKey a valid theme key name string
 * @returns a single string that contains each class necessary for the chosen theme
 */
const getThemeClasses = themeKey => {
  let classes = "";
  if (themeKey?.includes("ursa")) {
    classes += "ursa";
  } else {
    classes += "lodestar";
  }
  classes += ` ${themeKey}`;
  return classes;
};
exports.getThemeClasses = getThemeClasses;
//# sourceMappingURL=getThemeClasses.js.map